/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloTipoSociedad from 'Infotrack@Modelos/administracion/tipoSociedad';
import ITipoSociedad from 'Infotrack@Modelos/administracion/tipoSociedad/entidades/tipoSociedad';

export default class ControladorModeloTipoSociedad {
    private modeloTipoSociedad: ModeloTipoSociedad;
    constructor() {
        this.modeloTipoSociedad = new ModeloTipoSociedad();
    }

    public consultarTipoSociedad() {
        return this.modeloTipoSociedad.consultarTipoSociedad().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearTipoSociedad(tipoSociedad: ITipoSociedad) {
        await this.modeloTipoSociedad.crearTipoSociedad(tipoSociedad);
    }

    public async editarTipoSociedad(tipoSociedad: ITipoSociedad) {
        await this.modeloTipoSociedad.editarTipoSociedad(tipoSociedad);
    }

    public async eliminarTipoSociedad(tipoSociedad: ITipoSociedad) {
        await this.modeloTipoSociedad.eliminarTipoSociedad(tipoSociedad);
    }

    public validarEntidad(tipoSociedad: ITipoSociedad): boolean {
        if (tipoSociedad.CodigoTipoSociedad === '' || tipoSociedad.NombreTipoSociedad === '') {
            notificacionGlobal('comunes.alerta.camposIncompletos', 6000, 'warning', true);
            return false;
        }
        return true;
    }
}
